import {
  NodeExpandOutlined,
  FileDoneOutlined,
  ReconciliationOutlined,
  CloudDownloadOutlined,
  DeleteRowOutlined,
  TableOutlined,
  ControlOutlined,
  DiffOutlined,
  ApartmentOutlined,
  UserSwitchOutlined,
  UsergroupAddOutlined,
  SmileOutlined,
  SettingOutlined,
  ClusterOutlined,
  EyeOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Menu, Divider } from "antd";
import React, { useEffect, useState } from "react";
import styles from "../SidebarLayout.module.css";
import "../SidebarLayout.css";
import { Link, useLocation } from "react-router-dom";

import { ROUTES } from "../../../../config/consts/routes";

type MenuItem = Required<MenuProps>["items"][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: "group"
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}

const configurationItems: MenuItem[] = [
  getItem(
    <div>
      <Link to={ROUTES.configuration.projectSetup.route}>
        <ControlOutlined />
        <span>{ROUTES.configuration.projectSetup.name}</span>
      </Link>
    </div>,
    ROUTES.configuration.projectSetup.route,
    null
  ),
  getItem(
    <div>
      <Link to={ROUTES.configuration.tableSetup.tabs.tableSetup.route}>
        <TableOutlined />
        <span>{ROUTES.configuration.tableSetup.name}</span>
      </Link>
    </div>,
    ROUTES.configuration.tableSetup.route,
    null,
    [
      getItem(
        <div>
          <Link to={ROUTES.configuration.tableSetup.tabs.tableSetup.route}>
            <span>{ROUTES.configuration.tableSetup.tabs.tableSetup.name}</span>
          </Link>
        </div>,
        ROUTES.configuration.tableSetup.tabs.tableSetup.route,
        null
      ),
      getItem(
        <div>
          <Link to={ROUTES.configuration.tableSetup.tabs.translations.route}>
            <span>
              {ROUTES.configuration.tableSetup.tabs.translations.name}
            </span>
          </Link>
        </div>,
        ROUTES.configuration.tableSetup.tabs.translations.route,
        null
      ),
      getItem(
        <div>
          <Link to={ROUTES.configuration.tableSetup.tabs.references.route}>
            <span>{ROUTES.configuration.tableSetup.tabs.references.name}</span>
          </Link>
        </div>,
        ROUTES.configuration.tableSetup.tabs.references.route,
        null
      ),
    ]
  ),
];

const operationItems: MenuItem[] = [
  getItem(
    <div>
      <Link to={ROUTES.operation.import.route}>
        <CloudDownloadOutlined />
        <span>{ROUTES.operation.import.name}</span>
      </Link>
    </div>,
    ROUTES.operation.import.route,
    null
  ),

  getItem(
    <div>
      <Link to={ROUTES.operation.legacyMapping.tabs.mapping.route}>
        <NodeExpandOutlined />
        <span>{ROUTES.operation.legacyMapping.name}</span>
      </Link>
    </div>,
    ROUTES.operation.legacyMapping.route,
    null,
    [
      getItem(
        <div>
          <Link to={ROUTES.operation.legacyMapping.tabs.mapping.route}>
            <span>{ROUTES.operation.legacyMapping.tabs.mapping.name}</span>
          </Link>
        </div>,
        ROUTES.operation.legacyMapping.tabs.mapping.route,
        null
      ),
      getItem(
        <div>
          <Link to={ROUTES.operation.legacyMapping.tabs.mappingTemplates.route}>
            <span>
              {ROUTES.operation.legacyMapping.tabs.mappingTemplates.name}
            </span>
          </Link>
        </div>,
        ROUTES.operation.legacyMapping.tabs.mappingTemplates.route,
        null
      ),
    ]
  ),
  getItem(
    <div>
      <Link to={ROUTES.operation.migrationRules.tabs.ruleOverview.route}>
        <DeleteRowOutlined />
        <span>{ROUTES.operation.migrationRules.name}</span>
      </Link>
    </div>,
    ROUTES.operation.migrationRules.route,
    null,
    [
      getItem(
        <div>
          <Link to={ROUTES.operation.migrationRules.tabs.ruleOverview.route}>
            <span>
              {ROUTES.operation.migrationRules.tabs.ruleOverview.name}
            </span>
          </Link>
        </div>,
        ROUTES.operation.migrationRules.tabs.ruleOverview.route,
        null
      ),
      getItem(
        <div>
          <Link to={ROUTES.operation.migrationRules.tabs.ruleValues.route}>
            <span>{ROUTES.operation.migrationRules.tabs.ruleValues.name}</span>
          </Link>
        </div>,
        ROUTES.operation.migrationRules.tabs.ruleValues.route,
        null
      ),
      getItem(
        <div>
          <Link to={ROUTES.operation.migrationRules.tabs.ruleConditions.route}>
            <span>
              {ROUTES.operation.migrationRules.tabs.ruleConditions.name}
            </span>
          </Link>
        </div>,
        ROUTES.operation.migrationRules.tabs.ruleConditions.route,
        null
      ),
      getItem(
        <div>
          <Link to={ROUTES.operation.migrationRules.tabs.ruleResults.route}>
            <span>{ROUTES.operation.migrationRules.tabs.ruleResults.name}</span>
          </Link>
        </div>,
        ROUTES.operation.migrationRules.tabs.ruleResults.route,
        null
      ),
    ]
  ),
  getItem(
    <div>
      <Link to={ROUTES.operation.clustering.route}>
        <ClusterOutlined />
        <span>{ROUTES.operation.clustering.name}</span>
      </Link>
    </div>,
    ROUTES.operation.clustering.route,
    null
  ),
  getItem(
    <div>
      <Link to={ROUTES.operation.validationRules.tabs.validationMapping.route}>
        <ReconciliationOutlined />
        <span>{ROUTES.operation.validationRules.name}</span>
      </Link>
    </div>,
    ROUTES.operation.validationRules.route,
    null,
    [
      getItem(
        <div>
          <Link
            to={ROUTES.operation.validationRules.tabs.validationMapping.route}
          >
            <span>
              {ROUTES.operation.validationRules.tabs.validationMapping.name}
            </span>
          </Link>
        </div>,
        ROUTES.operation.validationRules.tabs.validationMapping.route,
        null
      ),
      getItem(
        <div>
          <Link
            to={ROUTES.operation.validationRules.tabs.validationRules.route}
          >
            <span>
              {ROUTES.operation.validationRules.tabs.validationRules.name}
            </span>
          </Link>
        </div>,
        ROUTES.operation.validationRules.tabs.validationRules.route,
        null
      ),
    ]
  ),
  // getItem(
  //   <div>
  //     <Link to={ROUTES.operation.enrichment.route}>
  //       <DiffOutlined />
  //       <span>{ROUTES.operation.enrichment.name}</span>
  //     </Link>
  //   </div>,
  //   ROUTES.operation.enrichment.route,
  //   null
  // ),
  getItem(
    <div>
      <Link to={ROUTES.operation.loadFileSetup.route}>
        <FileDoneOutlined />
        <span>{ROUTES.operation.loadFileSetup.name}</span>
      </Link>
    </div>,
    ROUTES.operation.loadFileSetup.route,
    null
  ),
  getItem(
    <div>
      <Link to={ROUTES.operation.publish.route}>
        <ExportOutlined />
        <span>{ROUTES.operation.publish.name}</span>
      </Link>
    </div>,
    ROUTES.operation.publish.route,
    null
  ),
];

const processingItems: MenuItem[] = [
  getItem(
    <div>
      <Link to={ROUTES.batchProcessing.processOverview.route}>
        <ApartmentOutlined />
        <span>{ROUTES.batchProcessing.processOverview.name}</span>
      </Link>
    </div>,
    ROUTES.batchProcessing.processOverview.route,
    null
  ),
  // getItem(
  //   <div>
  //     <Link to={ROUTES.batchProcessing.jobsOverview.route}>
  //       <AppstoreAddOutlined />
  //       <span>{ROUTES.batchProcessing.jobsOverview.name}</span>
  //     </Link>
  //   </div>,
  //   ROUTES.batchProcessing.jobsOverview.route,
  //   null
  // ),
];

const administrationItems: MenuItem[] = [
  getItem(
    <div>
      <Link to={ROUTES.administration.userManagement.route}>
        <UserSwitchOutlined />
        <span>{ROUTES.administration.userManagement.name}</span>
      </Link>
    </div>,
    ROUTES.administration.userManagement.route,
    null
  ),
  getItem(
    <div>
      <Link to={ROUTES.administration.groupManagement.route}>
        <UsergroupAddOutlined />
        <span>{ROUTES.administration.groupManagement.name}</span>
      </Link>
    </div>,
    ROUTES.administration.groupManagement.route,
    null
  ),
  getItem(
    <div>
      <Link to={ROUTES.administration.applicationSettings.route}>
        <SettingOutlined />
        <span>{ROUTES.administration.applicationSettings.name}</span>
      </Link>
    </div>,
    ROUTES.administration.applicationSettings.route,
    null
  ),
  getItem(
    <div>
      <Link to={ROUTES.excelAddin.excelSettings.tabs.userManagement.route}>
        <UserSwitchOutlined />
        <span>{ROUTES.excelAddin.excelSettings.name}</span>
      </Link>
    </div>,
    ROUTES.excelAddin.excelSettings.route,
    null,
    [
      getItem(
        <div>
          <Link to={ROUTES.excelAddin.viewManagement.route}>
            <span>{ROUTES.excelAddin.viewManagement.name}</span>
          </Link>
        </div>,
        ROUTES.excelAddin.viewManagement.route,
        null
      ),
      getItem(
        <div>
          <Link to={ROUTES.excelAddin.excelSettings.tabs.userManagement.route}>
            <span>
              {ROUTES.excelAddin.excelSettings.tabs.userManagement.name}
            </span>
          </Link>
        </div>,
        ROUTES.excelAddin.excelSettings.tabs.userManagement.route,
        null
      ),
      getItem(
        <div>
          <Link to={ROUTES.excelAddin.excelSettings.tabs.roleManagement.route}>
            <span>
              {ROUTES.excelAddin.excelSettings.tabs.roleManagement.name}
            </span>
          </Link>
        </div>,
        ROUTES.excelAddin.excelSettings.tabs.roleManagement.route,
        null
      ),
    ]
  ),
  getItem(
    <div>
      <Link to={ROUTES.administration.account.route}>
        <SmileOutlined />
        <span>{ROUTES.administration.account.name}</span>
      </Link>
    </div>,
    ROUTES.administration.account.route,
    null
  ),
];

const excelAddinItems: MenuItem[] = [
  getItem(
    <div>
      <Link to={ROUTES.excelAddin.excelSettings.tabs.userManagement.route}>
        <UserSwitchOutlined />
        <span>{ROUTES.excelAddin.excelSettings.name}</span>
      </Link>
    </div>,
    ROUTES.excelAddin.excelSettings.route,
    null,
    [
      getItem(
        <div>
          <Link to={ROUTES.excelAddin.excelSettings.tabs.userManagement.route}>
            <span>
              {ROUTES.excelAddin.excelSettings.tabs.userManagement.name}
            </span>
          </Link>
        </div>,
        ROUTES.excelAddin.excelSettings.tabs.userManagement.route,
        null
      ),
      getItem(
        <div>
          <Link to={ROUTES.excelAddin.excelSettings.tabs.roleManagement.route}>
            <span>
              {ROUTES.excelAddin.excelSettings.tabs.roleManagement.name}
            </span>
          </Link>
        </div>,
        ROUTES.excelAddin.excelSettings.tabs.roleManagement.route,
        null
      ),
      getItem(
        <div>
          <Link to={ROUTES.excelAddin.viewManagement.route}>
            <EyeOutlined />
            <span>{ROUTES.excelAddin.viewManagement.name}</span>
          </Link>
        </div>,
        ROUTES.excelAddin.viewManagement.route,
        null
      ),
    ]
  ),
];

const SidebarMenu = ({ sidebarCollapsed }: { sidebarCollapsed: boolean }) => {
  let location = useLocation();
  const [current, setCurrent] = useState(location.pathname);
  const [currentOpenKey, setCurrentOpenKey] = useState<any>([]);

  useEffect(() => {
    if (location) {
      if (current !== location.pathname) {
        setCurrent(location.pathname + location.search);
      }
    }
  }, [location, current]);

  function handleClick(e: any) {
    if (e.keyPath[1] !== currentOpenKey[0]) {
      setCurrentOpenKey([e.keyPath[1]]);
    }
    setCurrent(e.key);
    // setCurrentOpenKey([]);
  }

  const rootSubmenuKeys = [
    ROUTES.configuration.projectSetup.route,
    ROUTES.configuration.tableSetup.route,
    ROUTES.operation.import.route,
    ROUTES.operation.legacyMapping.route,
    ROUTES.operation.migrationRules.route,
    ROUTES.operation.validationRules.route,
    ROUTES.operation.enrichment.route,
    ROUTES.operation.loadFileSetup.route,
    ROUTES.operation.clustering.route,
    ROUTES.batchProcessing.processOverview.route,
    ROUTES.batchProcessing.jobsOverview.route,
    ROUTES.administration.userManagement.route,
    ROUTES.administration.groupManagement.route,
    ROUTES.administration.account.route,
    ROUTES.administration.applicationSettings.route,
    ROUTES.excelAddin.excelSettings.route,
    ROUTES.excelAddin.viewManagement.route,
  ];

  const onOpenChange: MenuProps["onOpenChange"] = (keys) => {
    const latestOpenKey = keys.find(
      (key) => currentOpenKey.indexOf(key) === -1
    );
    if (rootSubmenuKeys.indexOf(latestOpenKey!) === -1) {
      setCurrentOpenKey(keys);
    } else {
      setCurrentOpenKey(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  return (
    <div className={styles.sidebarMenuWrap}>
      {sidebarCollapsed ? (
        <div className={styles.sectionTitle}>
          <Divider className={styles.divider} />
        </div>
      ) : (
        <div className={styles.sectionTitle}>
          <span>CONFIGURATION</span>
        </div>
      )}
      <Menu
        defaultSelectedKeys={[""]}
        defaultOpenKeys={[""]}
        onClick={handleClick}
        selectedKeys={[current]}
        openKeys={currentOpenKey}
        onOpenChange={onOpenChange}
        mode="inline"
        theme="dark"
        items={configurationItems}
      />
      {sidebarCollapsed ? (
        <div className={styles.sectionTitle}>
          <Divider className={styles.divider} />
        </div>
      ) : (
        <div className={styles.sectionTitle}>
          <span>OPERATION</span>
        </div>
      )}
      <Menu
        defaultSelectedKeys={[""]}
        defaultOpenKeys={[""]}
        onClick={handleClick}
        openKeys={currentOpenKey}
        onOpenChange={onOpenChange}
        selectedKeys={[current]}
        mode="inline"
        theme="dark"
        items={operationItems}
      />
      {sidebarCollapsed ? (
        <div className={styles.sectionTitle}>
          <Divider className={styles.divider} />
        </div>
      ) : (
        <div className={styles.sectionTitle}>
          <span>BATCH PROCESSING</span>
        </div>
      )}
      <Menu
        defaultSelectedKeys={[""]}
        defaultOpenKeys={[""]}
        onClick={handleClick}
        selectedKeys={[current]}
        openKeys={currentOpenKey}
        onOpenChange={onOpenChange}
        mode="inline"
        theme="dark"
        items={processingItems}
      />
      {sidebarCollapsed ? (
        <div className={styles.sectionTitle}>
          <Divider className={styles.divider} />
        </div>
      ) : (
        <div className={styles.sectionTitle}>
          <span>ADMINISTRATION</span>
        </div>
      )}
      <Menu
        defaultSelectedKeys={[""]}
        defaultOpenKeys={[""]}
        onClick={handleClick}
        selectedKeys={[current]}
        mode="inline"
        theme="dark"
        items={administrationItems}
      />
    </div>
  );
};

export default SidebarMenu;
